import React, { useState } from "react";
import Button from "../../../components/buttons/Button";
import Dialog from "../../../components/dialog/Dialog";
import Content from "../../../components/Content";
import { useNavigate } from "react-router-dom";
import { MaterialTable } from "../../../components/service/MaterialTable";
import { CreateMaterialModal } from "../../../modals/service/CreateMaterialModal";
import SearchInput from "../../../components/Inputs/SearchInput";
import { Typography, Box, Card, CardContent } from "@mui/material";

export const MaterialView = () => {
  const navigate = useNavigate();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);

  const clickRow = (id) => {
    navigate(`./overview/${id}`);
  };

  return (
    <>
      <Content title={"Material"}>
        <Box sx={{ p: 3 }}>
          <Card sx={{ mb: 3 }}>
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2,
                }}
              >
                <Typography variant="h6" gutterBottom>
                  Material
                </Typography>
                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <SearchInput />
                  <Button onClick={() => setIsCreateModalOpen(true)}>
                    Skapa Nytt Material
                  </Button>
                </Box>
              </Box>
              <Typography variant="body1" color="text.secondary">
                Hantera material för din organisation. Skapa och organisera olika material som kan kopplas till tjänster och aktiviteter för bättre spårning och hantering.
              </Typography>
            </CardContent>
          </Card>

          <Card>
            <CardContent>
              <MaterialTable handleSelect={(item) => clickRow(item.id)} />
            </CardContent>
          </Card>
        </Box>
          <Dialog
            open={isCreateModalOpen}
            onClose={() => setIsCreateModalOpen(false)}
            title="Skapa Material"
          >
            <CreateMaterialModal
              closeCreateModal={() => setIsCreateModalOpen(false)}
            />
          </Dialog>
      </Content>
    </>
  );
};
